import React from 'react';
export var UnsupportedAttachment = function (_a) {
    var _b;
    var attachment = _a.attachment;
    return (React.createElement("div", null,
        React.createElement("div", null,
            "Unsupported attachment type ",
            React.createElement("strong", null, (_b = attachment.type) !== null && _b !== void 0 ? _b : 'unknown')),
        React.createElement("code", null, JSON.stringify(attachment, null, 4)),
        ";"));
};
export var NullComponent = function () { return null; };
